// extracted by mini-css-extract-plugin
module.exports = {"textValue":"styles_textValue__12Gqt","dropzone":"styles_dropzone__3Tnsj","submitBtn":"styles_submitBtn__1oYvQ","fieldError":"styles_fieldError__1_ayH"};